import { WidgetType } from '../content/contentBuilder/widgets/widgetType';
import { ContentFragmentType } from '../content/contentBuilder/Content';
export const convertImageCarouselWidgetToServerModel = (widget) => {
    const assetIds = [];
    const captions = [];
    for (const value of widget.value.data.images) {
        assetIds.push(value.assetId);
        captions.push(value.caption);
    }
    return {
        id: widget._id,
        trackingIdentifier: widget.trackingIdentifier,
        type: WidgetType.imageCarousel,
        data: {
            assets: assetIds,
            captions: captions,
        },
        properties: {
            displayDelayInSeconds: widget.value.properties.displayDelayInSeconds,
            isRequired: widget.value.properties.isRequired,
        },
    };
};
export const convertImageCarouselFromServerModel = (serverModel) => {
    var _a;
    const numberOfAssets = serverModel.data.assets.length;
    const numberOfSlides = numberOfAssets;
    const slides = [];
    for (let i = 0; i < numberOfSlides; i++) {
        const slide = {
            assetId: serverModel.data.assets[i],
            caption: serverModel.data.captions[i],
        };
        slides.push(slide);
    }
    return {
        _id: serverModel.id,
        type: ContentFragmentType.Widget,
        initialized: true,
        trackingIdentifier: serverModel.trackingIdentifier,
        value: {
            type: WidgetType.imageCarousel,
            data: {
                images: slides,
            },
            properties: {
                displayDelayInSeconds: serverModel.properties.displayDelayInSeconds,
                isRequired: (_a = serverModel.properties.isRequired) !== null && _a !== void 0 ? _a : false,
            },
        },
    };
};
